import { render, staticRenderFns } from "./SwitchUploadCsv.vue?vue&type=template&id=0ff8e196&"
import script from "./SwitchUploadCsv.vue?vue&type=script&lang=js&"
export * from "./SwitchUploadCsv.vue?vue&type=script&lang=js&"
import style0 from "./SwitchUploadCsv.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VScrollXReverseTransition } from 'vuetify/lib/components/transitions';
import { VScrollXTransition } from 'vuetify/lib/components/transitions';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VContainer,VRow,VScrollXReverseTransition,VScrollXTransition,VSwitch})
